import topEarn from './topEarn';

export default topEarn;
